import React, { useState } from "react";

export default function Header(props) {
  const [activePage, setActivePage] = useState("home");

  const sendNavLinks = (id) => {
    setActivePage(id);
    props.navLink(id);
  };

  return (
    <>
      <header className="fixed-top header">
        <div className="top-header py-2 bg-white">
          <div className="container">
            <div className="row no-gutters">
              <div className="col-lg-4 text-center text-lg-left">
                <a className="text-color mr-3" href="tel:+92345447745">
                  <strong>CALL</strong> +92 34-544-7745
                </a>
                <ul className="list-inline d-inline">
                  <li className="list-inline-item mx-0">
                    <a
                      className="d-inline-block p-2 text-color"
                      target="_blank"
                      href="https://web.facebook.com/haroon.malik.549"
                      rel="noreferrer"
                    >
                      <i className="ti ti-facebook"></i>
                    </a>
                  </li>
                  <li className="list-inline-item mx-0" title="Location">
                    <a
                      className="d-inline-block p-2 text-color"
                      target="_blank"
                      href="https://maps.app.goo.gl/hUFpafrPK64pF1dy5"
                      rel="noreferrer"
                    >
                      <i className="ti ti-location-pin"></i>
                    </a>
                  </li>
                  <li className="list-inline-item mx-0">
                    <a
                      className="d-inline-block p-2 text-color"
                      target="_blank"
                      href="https://www.instagram.com/haroonmalik34/"
                      rel="noreferrer"
                    >
                      <i className="ti ti-instagram"></i>
                    </a>
                  </li>
                  <li className="list-inline-item mx-0">
                    <a
                      className="d-inline-block p-2 text-color"
                      href="https://www.linkedin.com/in/haroon-rasheed-380b53118/"
                      rel="noreferrer"
                      target="_blank"
                    >
                      <i className="ti ti-linkedin"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="navigation w-100">
          <div className="container">
            <nav className="navbar navbar-expand-lg navbar-dark p-0">
              
              <button
                className="navbar-toggler rounded-0"
                type="button"
                data-toggle="collapse"
                data-target="#navigation"
                aria-controls="navigation"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon"></span>
              </button>

              <div className="collapse navbar-collapse" id="navigation">
                <ul className="navbar-nav ml-auto text-center">
                  <li
                    className={
                      activePage === "home"
                        ? "nav-item @@home active"
                        : "nav-item @@home"
                    }
                  >
                    <div
                      className="nav-link"
                      id="home"
                      onClick={() => sendNavLinks("home")}
                    >
                      Home
                    </div>
                  </li>
                  <li
                    className={
                      activePage === "about" ? "nav-item active" : "nav-item"
                    }
                  >
                    <div
                      className="nav-link"
                      id="about"
                      onClick={() => sendNavLinks("about")}
                    >
                      About
                    </div>
                  </li>

                  <li
                    className={
                      activePage === "team"
                        ? "nav-item @@events active"
                        : "nav-item @@events"
                    }
                  >
                    <div
                      className="nav-link"
                      id="team"
                      onClick={() => sendNavLinks("team")}
                    >
                      Our Team
                    </div>
                  </li>
                  {/* <li className="nav-item @@blog">
                    <a className="nav-link" id="blog" onClick={newHref}>
                      BLOG
                    </a>
                  </li> */}

                  <li
                    className={
                      activePage === "contact"
                        ? "nav-item @@contact active"
                        : "nav-item @@contact"
                    }
                  >
                    <div
                      className="nav-link"
                      id="contact"
                      onClick={() => sendNavLinks("contact")}
                    >
                      CONTACT
                    </div>
                  </li>
                </ul>
              </div>
            </nav>
          </div>
        </div>
      </header>
    </>
  );
}
